import { SignableOfferForm } from '../..';
import { SIGNABLE_OFFER_VARIABLES } from '../../../variables';

export const KNOWN_VARIABLES = SIGNABLE_OFFER_VARIABLES.filter(
  (v) => v.form,
).map((v) => v.name);

export function isFormValid(form: SignableOfferForm, variables?: string[]) {
  if (variables == null) {
    return false;
  }

  for (const variable of variables) {
    switch (variable) {
      case 'bonus':
        if (!form.bonus || !form.bonusCurrency) {
          return false;
        }
        break;
      case 'candidateName':
        if (!form.candidateName) {
          return false;
        }
        break;
      case 'companyName':
        if (!form.companyName) {
          return false;
        }
        break;
      case 'directManager':
        if (!form.directManager) {
          return false;
        }
        break;
      case 'equity':
        if (!form.equity) {
          return false;
        }
        break;
      case 'jobTitle':
        if (!form.jobTitle) {
          return false;
        }
        break;
      case 'offerExpirationDate':
        if (!form.offerExpirationDate) {
          return false;
        }
        break;
      case 'paidTimeOff':
        if (!form.paidTimeOff) {
          return false;
        }
        break;
      case 'salary':
        if (!form.salary || !form.salaryCurrency) {
          return false;
        }
        break;
      case 'senderName':
        if (!form.senderName) {
          return false;
        }
        break;
      case 'sickDays':
        if (!form.sickDays) {
          return false;
        }
        break;
      case 'startingDate':
        if (!form.startingDate) {
          return false;
        }
        break;
      case 'todayDate':
        if (!form.todayDate) {
          return false;
        }
        break;
      case 'workingHours':
        if (!form.workingHours) {
          return false;
        }
        break;
      default:
        if (!form.customVariables.get(variable)) {
          return false;
        }
        break;
    }
  }

  return true;
}
